module.exports = __webpack_public_path__ + "src/assets/img/1_1art_2part_gallery.6439fd71.jpg";